import React from 'react';
import { FlexWrapper, MarginWrapper, StyledAudienceItem } from '../../Styled';

interface IAudience {
  audience: string[];
}

export const Audience: React.FC<IAudience> = props => {
  const { audience } = props;

  return audience.length ? (
    <MarginWrapper margin="19px 0 0 0">
      <FlexWrapper data-testid="audience">
        {audience.map((audienceItem, index) => (
          <StyledAudienceItem key={index}>{audienceItem}</StyledAudienceItem>
        ))}
      </FlexWrapper>
    </MarginWrapper>
  ) : null;
};
